import { Routes } from '@angular/router';
import { authCanMatch, authGuard, guestGuard, organizationCanMatch, organizationGuard } from './guards/auth.gard';
import { HealthCheckResolver } from './services/health-check.resolver';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./layout/layout.component').then(m => m.LayoutComponent),
    canActivate: [authGuard],
    loadChildren: () => import('./layout/kore.routes').then(m => m.KORE_ROUTES)
  },
  {
    path: 'admin',
    loadComponent: () => import('./layout/admin-layout/admin-layout').then(m => m.AdminLayoutComponent),
    canActivate: [authGuard, organizationGuard],
    canActivateChild: [organizationGuard],
    canMatch: [authCanMatch, organizationCanMatch],
    loadChildren: () => import('./layout/admin.routes').then(m => m.ADMIN_ROUTES)
  },
  {
    path: 'login',
    loadComponent: () => import('./users/sign-in/sign-in.component').then(m => m.SignInComponent),
    canActivate: [guestGuard]
  },
  {
    path: 'sign-in',
    loadComponent: () => import('./users/sign-in/sign-in.component').then(m => m.SignInComponent),
    canActivate: [guestGuard]
  },
  {
    path: 'signup',
    loadComponent: () => import('./users/sign-up/sign-up.component').then(m => m.SignUpComponent),
    canActivate: [guestGuard]
  },
  {
    path: 'verify',
    loadComponent: () => import('./users/verify-email/verify-email.component').then(m => m.VerifyEmailComponent)
  },
  {
    path: 'verify-email',
    loadComponent: () => import('./users/verify-email/verify-email.component').then(m => m.VerifyEmailComponent)
  },
  {
    path: 'health',
    resolve: { health: HealthCheckResolver },
    loadComponent: () => import('./shared/components/healt-check.component').then(m => m.HealtCheckComponent)
  },
  {
    path: 'auth/callback',
    loadComponent: () => import('./auth/authorization-complete/authorization-complete.component').then(m => m.AuthorizationCompleteComponent)
  }

];
